import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Form } from 'semantic-ui-react';
import { Commons } from 'components';
import cm from 'helpers/commons';

class ChangeInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      header: [
        { data: '#', textAlign: 'left' },
        { data: '날짜', textAlign: 'left' },
        { data: '변경된 사용자', textAlign: 'left' },
        { data: '변경 항목', textAlign: 'left' },
        { data: '상세내역', textAlign: 'left' },
        { data: '상태', textAlign: 'center' },
        { data: '변경한 사람', textAlign: 'left' }
      ],
      page: 1,
      pagerow: 10,
      selOptions: [
        { text: '변경 항목 전체', value: 'ALL' },
        { text: '계정 탈퇴', value: 'WITHDRAW' },
        { text: '계정 일시정지', value: 'INACTIVE' },
        { text: '계정 일시정지 해제', value: 'ACTIVE' }
      ],
      isLoadingBar: false,
      keyword: null,
      status: null
    };
  }

  pageClick = (pageNum) => {
    const { changeInfoList, fn } = this.props;
    const { keyword, status } = this.state;
    let page_total = 0;
    let page_row = 10;

    if (changeInfoList && changeInfoList.data) {
      const { total, pageRow } = changeInfoList.data;
      page_total = total;
      page_row = pageRow;
    }
    const params = {
      page: pageNum,
      pageRow: page_row,
      total: page_total,
      type: status || 'ALL',
      keyword
    };

    fn.changeInfoSel(params);
  };

  handleChange = async (e, data) => {
    if (data.type === 'text') {
      this.setState({ keyword: data.value });
    } else {
      await this.setState({ status: data.value });
      this.search();
    }
  };

  search = () => {
    const { fn } = this.props;
    const { keyword, status } = this.state;
    const params = {
      page: 1,
      pageRow: 10,
      type: status || 'ALL',
      keyword
    };
    fn.changeInfoSel(params);
  };

  render() {
    const { changeInfoList, fn } = this.props;
    const { header, status, keyword, selOptions } = this.state;
    let pagination_page = 1;
    let pagination_pagerow = 0;
    let pagination_totalcount = 0;
    const tabledata = {
      header: {
        main: header
      },
      body: {
        message: '내역이 존재하지 않습니다.',
        main: null
      }
    };

    const button = (
      <Button
        inverted
        color="red"
        style={{ width: '100px' }}
        // onClick={e => fn.confirmOpen(true, null, item)}
      >
        {' '}
        예약취소{' '}
      </Button>
    );
    if (changeInfoList && changeInfoList.data) {
      const { content, page, pageRow, total } = changeInfoList.data;
      pagination_page = page;
      pagination_pagerow = pageRow;
      pagination_totalcount = total;

      tabledata.body.main = content.map((item) => {
        const type = {
          status: '-',
          timeText: '-'
        };
        let status = '-';
        let time = '';
        const cancleTime = item.canceled ? ` / 취소시각: ${cm.yyyyMMddhhmm(item.canceled)}` : '';
        const signId = item.reservedSignId ? `(${item.reservedSignId})` : '';
        let fontColor = null;

        switch (item.type) {
          case 'WITHDRAW':
            type.status = '계정 탈퇴';
            type.timeText = '탈퇴';
            break;
          case 'INACTIVE':
            type.status = '계정 일시정지';
            type.timeText = '일시정지';
            break;
          case 'ACTIVE':
            type.status = '일시정지 해제';
            type.timeText = '변경';
            break;
          case 'DORMANT':
            type.status = '계정 휴면';
            type.timeText = '1년 이상 식권대장을 사용하지않은 사용자 계정 휴면 처리';
            break;
          case 'RESTORE':
            type.status = '계정 휴면 해제';
            type.timeText = '사용자 본인 로그인으로 계정 휴면 해제';
            break;
          default:
            type.status = item.typeName;
            type.timeText = item.typeName;
            break;
        }

        switch (item.status) {
          case 'READY':
            time = `예약 시각: ${cm.yyyyMMddhhmm(item.reserved)}`;
            status = (
              <Button
                inverted
                color="red"
                style={{ width: '100px' }}
                onClick={(e) => fn.cancelReserve(item.infoHistoryIdx)}
              >
                예약취소
              </Button>
            );
            break;
          case 'CANCELED':
            time = `예약 시각: ${cm.yyyyMMddhhmm(item.reserved)} ${cancleTime}`;
            status = '취소';
            break;
          case 'DONE':
            time = `${type.timeText} 시각: ${cm.yyyyMMddhhmm(item.executed)}`;
            status = '완료';
            if (item.type === 'DORMANT' || item.type === 'RESTORE') {
              time = type.timeText;
            }
            break;
          case 'FAILED':
            time = (
              <div>
                <span>실패 시각: {cm.yyyyMMddhhmm(item.executed)}</span>
                <br />
                <div
                  style={{
                    maxWidth: 300,
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden'
                  }}
                >
                  {item.result}
                </div>
              </div>
            );
            status = '실패';
            fontColor = 'red';
            break;
          default:
            status = item.statusName;
            time = type.timeText;
            break;
        }
        const obj = {
          row: [
            { data: item.infoHistoryIdx, textAlign: 'left' },
            { data: cm.yyyyMMddhhmm(item.created), textAlign: 'left' },
            { data: `${item.reservedUserName} ${signId}`, textAlign: 'left' },
            { data: type.status, textAlign: 'left' },
            { data: time, textAlign: 'left' },
            { data: status, textAlign: 'center', fontColor },
            { data: item.createdUserName, textAlign: 'left' }
          ]
        };

        return obj;
      });
    }

    return (
      <div>
        {changeInfoList && changeInfoList.data ? (
          <div>
            <Form>
              <Form.Group>
                <Form.Dropdown
                  search
                  selection
                  defaultValue={status || 'ALL'}
                  options={selOptions}
                  onChange={this.handleChange}
                />
                <Form.Input
                  className="change-info-input"
                  placeholder="부서명, 이름, ID"
                  value={keyword || ''}
                  onChange={this.handleChange}
                  action={{
                    icon: 'search',
                    onClick: (e) => this.search(e)
                  }}
                />
              </Form.Group>
            </Form>
            <div className="table-box">
              <Commons.TableForm selectable="true" tabledata={tabledata} />
            </div>
            <div className="table-paging">
              <Commons.Pagination
                page={pagination_page}
                pageRow={pagination_pagerow}
                pageBlock={10}
                totalCount={pagination_totalcount}
                pageClick={this.pageClick}
              />
            </div>
          </div>
        ) : (
          <Commons.LoadingBar />
        )}
      </div>
    );
  }
}

ChangeInformation = connect((state) => ({
  changeInfoList: state.company.changeInfoList
}))(ChangeInformation);

export default ChangeInformation;
